<script lang="ts" module>
  import type { Snippet } from 'svelte';

  export interface BasePillProps {
    children: Snippet;
    class?: string;
  }
</script>

<script lang="ts">
  let { ...props }: BasePillProps = $props();
</script>

<div
  class="w-fit rounded-sm px-2 py-1 font-sans text-label-sm font-normal text-c-base {props.class}"
>
  {@render props.children()}
</div>
